/**
 * @owner @Appboy/whats-app
 */

// generated from 1_227 samples

import { z } from "zod";
import { common } from "../common";
import { messageGetBaseSchema } from "./messageGetBaseSchema";
import { grapesJsDataSchema } from "../grapesJs/grapesJsDataSchema";

export const lineMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("line"),
  campaign_base_id: common.objectId.optional(),
  is_control: z.boolean().optional(),
  variation_id: common.objectId,
  click_tracking_enabled: z.boolean().nullable().optional(),
  // undefined: 318 (25.92%), defined 909 (74.08%)
  // null: 212 (23.32%)
  grapes_js_data: grapesJsDataSchema.nullable().optional(),
  link_template_ids: z.array(z.string()).nullable(),
  // undefined: 318 (25.92%), defined 909 (74.08%)
  messages: z
    .array(
      z.discriminatedUnion("type", [
        // "carousel" 190 (15.50%)
        z.object({
          type: z.literal("carousel"),
          cards: z.array(
            z.object({
              actions: z.array(
                z.object({
                  // null: 32 (8.16%)
                  label: z.string().nullable(),
                  // true 87 (22.19%), false 305 (77.81%)
                  open_with_line_browser: z.boolean(),
                  type: z.literal("uri"),
                  // null: 33 (8.42%)
                  uri: z.string().nullable(),
                })
              ),
              // undefined: 144 (40.56%), defined 211 (59.44%)
              default_action: z
                .object({
                  // null: 10 (4.74%)
                  label: z.string().nullable(),
                  // true 44 (20.85%), false 167 (79.15%)
                  open_with_line_browser: z.boolean(),
                  type: z.literal("uri"),
                  uri: z.string().nullable(),
                })
                .optional(),
              // undefined: 34 (9.58%), defined 321 (90.42%)
              image_url: z.string().nullable().optional(),
              // null: 28 (7.89%)
              text: z.string().nullable(),
              // undefined: 111 (31.27%), defined 244 (68.73%)
              title: z.string().nullable().optional(),
            })
          ),
          carousel_type: z.literal("carousel"),
          image_aspect_ratio: z.enum(["rectangle", "square"]).nullable(),
          image_size: z.enum(["cover", "contain"]).nullable(),
          title: z.string().nullable(),
        }),
        // "image" 158 (12.89%)
        z.object({
          type: z.literal("image"),
          image_url: z.string().nullable(),
          // Editor-only Media Library pick (Braze::Channels::Line::ImageMessage#as_json, only for a pick); never sent to LINE.
          media_library: z.object({ file_name: z.string(), asset_id: z.string().optional() }).optional(),
        }),
        // "rich_message" 222 (18.11%)
        z.object({
          type: z.literal("rich_message"),
          actions: z.array(
            z.object({
              area: z.object({
                // undefined: 303 (99.34%), defined 2 (0.66%)
                h: z.number().min(1).optional(),
                // undefined: 2 (0.66%), defined 303 (99.34%)
                // integer: 294 (97.03%)
                // avg: 889.43, min: 42, max: 6760
                height: z.number().nonnegative().optional(),
                // undefined: 303 (99.34%), defined 2 (0.66%)
                w: z.number().min(1).optional(),
                // undefined: 2 (0.66%), defined 303 (99.34%)
                // integer: 285 (94.06%)
                // avg: 1015.61, min: 21, max: 7800
                width: z.number().nonnegative().optional(),
                // integer: 294 (96.39%)
                // avg: 49.73, min: 0, max: 700
                x: z.number().min(0),
                // integer: 300 (98.36%)
                // avg: 88.26, min: 0, max: 780
                y: z.number().min(0),
              }),
              // undefined: 235 (77.05%), defined 70 (22.95%)
              label: z.string().nullable().optional(),
              // true 35 (11.48%), false 270 (88.52%)
              open_with_line_browser: z.boolean(),
              type: z.literal("uri"),
              // null: 45 (14.75%)
              uri: z.string().nullable(),
            })
          ),
          base_size: z.object({
            height: z.int().nonnegative(),
            width: z.int().nonnegative(),
          }),
          image_url: z.string().nullable(),
          title: z.string().nullable(),
        }),
        // "text" 656 (53.51%)
        z.object({
          type: z.literal("text"),
          body: z.string().nullable(),
        }),
      ])
    )
    .nullable()
    .optional(),
  optimal_send_percentage: z.int().min(0).max(100).nullable().optional(),
  // undefined: 318 (25.92%), defined 909 (74.08%)
  // null: 139 (15.29%)
  messaging_service_id: common.objectId.nullable().optional(),
  selected_messaging_service: z
    .object({
      id: common.objectId,
      name: z.string(),
      subscription_group: z.object({
        external_id: z.string(),
        id: common.objectId,
        link_shortening_domain: z.string().optional(),
        name: z.string(),
      }),
    })
    .nullable()
    .optional(),
});
